<section class="container">
  <small class="text-muted" *ngIf="dataAtualizacao">
    atualizado em: {{ dataAtualizacao | date: 'yyyy-MM-dd HH:mm:ss' }}
  </small>

  <div class="table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col">
            <bn-ordenacao
              [ordenacao]="atributosOrdenacao"
              [atributo]="'agenteFinanceiro'"
              [nomeAtributoExibicao]="'Agente Financeiro'"
              (aoClickar)="mudancaOrdenacao($event)">
            </bn-ordenacao>
          </th>

          <th scope="col">
            <bn-ordenacao
              [ordenacao]="atributosOrdenacao"
              [atributo]="'limiteAdicional'"
              [nomeAtributoExibicao]="'Limite Adicional'"
              (aoClickar)="mudancaOrdenacao($event)">
            </bn-ordenacao>
          </th>

          <th scope="col">
            <bn-ordenacao
              [ordenacao]="atributosOrdenacao"
              [atributo]="'valorLimite'"
              [nomeAtributoExibicao]="'Valor Limite'"
              (aoClickar)="mudancaOrdenacao($event)">
            </bn-ordenacao>
          </th>

          <th scope="col">
            <bn-ordenacao
              [ordenacao]="atributosOrdenacao"
              [atributo]="'codigosPrograma'"
              [nomeAtributoExibicao]="'Código Programa'"
              (aoClickar)="mudancaOrdenacao($event)">
            </bn-ordenacao>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of limitesAdicionais">
          <td>{{ item.agenteFinanceiro }}</td>

          <td>
            {{ item.limiteAdicional }}

            <i
              class="fa fa-calendar cursor-pointer margin-left-5"
              [ngbPopover]="popoverDatas"
              triggers="click"
              placement="top"
              popoverTitle="Validade"
              popoverClass="popover-datas-limite">
            </i>

            <ng-template #popoverDatas>
              <div><b>Início:</b> {{ item.dataInicioProtocolo | date: 'dd/MM/yyyy' }}</div>
              <div><b>Fim:</b> {{ item.dataFimProtocolo | date: 'dd/MM/yyyy' }}</div>
            </ng-template>
          </td>

          <td>{{ item.valorLimite | currency: 'BRL':'symbol':'1.2-2' }}</td>

          <td>
            <ng-container *ngIf="item.codigosPrograma?.length > 2 && !expandidos[item.ide]; else todosCodigos">
              {{ item.codigosPrograma[0] }}, {{ item.codigosPrograma[1] }}
              <a href="javascript:void(0)"
                 (click)="toggleCodigos(item.ide)"
                 ngbTooltip="Exibir todos os códigos">...</a>
            </ng-container>

            <ng-template #todosCodigos>
              <span (click)="toggleCodigos(item.ide)" style="cursor: pointer;">
                {{ item.codigosPrograma?.join(', ') }}
              </span>
            </ng-template>
          </td>
        </tr>

        <tr *ngIf="limitesAdicionais.length == 0">
          <td colspan="4" class="text-center text-muted">
            Nenhum limite adicional encontrado.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>